var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "client-details",
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_c('p', {
    staticClass: "client-form-help"
  }, [_vm._v("Stačia základné údaje klienta. Hypotéku ani jej účel teraz nezadávate.")]), _vm._l(_vm.fields, function (field) {
    return _c('div', {
      key: field.key,
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "field-label",
      attrs: {
        "for": "".concat(_vm.formId, "-").concat(field.key)
      }
    }, [_vm._v(_vm._s(field.label))]), field.type === 'checkbox' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.key],
        expression: "form[field.key]"
      }],
      ref: "fields",
      refInFor: true,
      staticClass: "text-input w-input",
      attrs: {
        "form": "",
        "id": "".concat(_vm.formId, "-").concat(field.key),
        "required": field.required,
        "disabled": _vm.saving,
        "autocomplete": field.autocomplete,
        "maxlength": field.key === 'telephone' ? 32 : 150,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.form[field.key]) ? _vm._i(_vm.form[field.key], null) > -1 : _vm.form[field.key]
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.form[field.key],
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.form, field.key, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.form, field.key, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.form, field.key, $$c);
          }
        }
      }
    }) : field.type === 'radio' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.key],
        expression: "form[field.key]"
      }],
      ref: "fields",
      refInFor: true,
      staticClass: "text-input w-input",
      attrs: {
        "form": "",
        "id": "".concat(_vm.formId, "-").concat(field.key),
        "required": field.required,
        "disabled": _vm.saving,
        "autocomplete": field.autocomplete,
        "maxlength": field.key === 'telephone' ? 32 : 150,
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.form[field.key], null)
      },
      on: {
        "change": function change($event) {
          return _vm.$set(_vm.form, field.key, null);
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.key],
        expression: "form[field.key]"
      }],
      ref: "fields",
      refInFor: true,
      staticClass: "text-input w-input",
      attrs: {
        "form": "",
        "id": "".concat(_vm.formId, "-").concat(field.key),
        "required": field.required,
        "disabled": _vm.saving,
        "autocomplete": field.autocomplete,
        "maxlength": field.key === 'telephone' ? 32 : 150,
        "type": field.type
      },
      domProps: {
        "value": _vm.form[field.key]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.form, field.key, $event.target.value);
        }
      }
    })]);
  }), _vm.error ? _c('p', {
    staticClass: "clientError",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _c('div', {
    staticClass: "client-actions"
  }, [_c('button', {
    staticClass: "client-save",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.saving ? 'Ukladám…' : _vm.client ? 'Uložiť údaje' : 'Vytvoriť klienta'))]), _c('button', {
    staticClass: "client-cancel",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v("Späť")])])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }